import { Box } from '@mui/material';
import React from 'react';
import SearchInput from '~/components/Inputs/Search';
import { Modality } from '~/domain/dicom/modality';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import BodyPartSelect from './BodyPartSelect';
import ModalitySelect from './ModalitySelect';

type ModelSearchProps = {
    availableModels?: PredictionModel[];
    modelSearch: string;
    setModelSearch: (search: string) => void;
    selectedBodyPart: string;
    setSelectedBodyPart: (part: string) => void;
    modelModality?: Modality[];
    setModelModality?: (modality: Modality[]) => void;
};

const ModelSearch: React.FC<ModelSearchProps> = ({
    availableModels,
    modelSearch,
    setModelSearch,
    selectedBodyPart,
    setSelectedBodyPart,
    modelModality,
    setModelModality,
}) => (
    <Box display="flex" gap={2} mb={1}>
        <BodyPartSelect
            availableModels={availableModels}
            selectedBodyPart={selectedBodyPart}
            setSelectedBodyPart={setSelectedBodyPart}
        />
        <SearchInput value={modelSearch} onChange={setModelSearch} />
        {setModelModality && modelModality && (
            <ModalitySelect
                modality={modelModality}
                setModality={setModelModality}
            />
        )}
    </Box>
);

export default ModelSearch;
